
<svg xmlns="http://www.w3.org/2000/svg" class="d-none">
  <symbol id="check2" viewBox="0 0 16 16">
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
  </symbol>
  <symbol id="circle-half" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>
  </symbol>
  <symbol id="moon-stars-fill" viewBox="0 0 16 16">
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
    <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>
  </symbol>
  <symbol id="sun-fill" viewBox="0 0 16 16">
    <path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>
  </symbol>
  <symbol id="check" viewBox="0 0 16 16">
    <title>Check</title>
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
  </symbol>
</svg>

<!-- Overview -->
<div id="ntrip-caster-section" class="container col-xxl-8 px-4" style="scroll-margin-top: 72px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-3">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/images/landing/GeoAstra_PPK_Studio_small.png"
           class="d-block mx-lg-auto img-fluid lnc-zoom-img rtk-expert-hero-img"
           alt="GeoAstra RTK Expert"
           width="700"
           height="500"
           loading="lazy"
           (click)="openLightbox('assets/images/landing/GeoAstra_PPK_Studio_small.png','GeoAstra RTK Expert')">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">GeoAstra RTK Expert</h1>
      <h2 class="display-5 lh-1 mb-3">GeoAstra RTK Expert is a no-install, web-based RTK / PPK utility toolkit that includes the below 3 utilities.</h2>

      <ul class="rtk-expert-tools list-unstyled mb-4">
        <li class="tool-block mb-3">
          <h3 class="tool-subtitle">PPK Studio</h3>
          <p class="tool-text mb-0">
            Turn raw GNSS rover and base data into centimeter-level accuracy positions, with quality plots, satellite map verification, and multiple export formats.
          </p>
        </li>
        <li class="tool-block mb-3">
          <h3 class="tool-subtitle">PPK Downloader</h3>
          <p class="tool-text mb-0">
            Download RTCM or RTK base data from any CORS or NTRIP mountpoint and use it directly for PPK, cutting equipment costs by over 50% and simplifying your workflow.
          </p>
        </li>
        <li class="tool-block">
          <h3 class="tool-subtitle">RTK Base Analyzer</h3>
          <p class="tool-text mb-0">
            Analyze any NTRIP mountpoint to gain detailed insights directly from its RTCM data stream.
          </p>
        </li>
      </ul>

      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4" (click)="login()">Login</button>
        <button type="button" class="btn btn-primary btn-lg px-4 me-md-2" (click)="signup()">Sign-up</button>
      </div>
    </div>
  </div>
</div>

<!-- pricing-section -->
<div id="pricing-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="container py-3">
    <main>
      <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Pricing</h1>
      </div>
      <div class="row g-3 mb-3 text-center align-items-stretch justify-content-center">
        <div class="col-12 col-md-6 col-lg-5 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Free</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$0<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4 pricing-list">
                <li>PPK Studio</li>
                <li>100MB upload file size limit</li>
                <li>Forum support</li>
                <li>Email support</li>
                <li>Shared server environment</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-outline-primary" (click)="signup()">Sign up</button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-5 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Pro</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$39<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4 pricing-list">
                <li>PPK Studio</li>
                <li>1GB upload file size limit</li>
                <li>Unlimited mountpoint connections</li>
                <li>PPK Downloader</li>
                <li>RTK Base Analyzer</li>
                <li>Forum support</li>
                <li>Email support</li>
                <li>Shared server environment</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="openUrl('https://gpswebshop.com/products/geoastra-ntrip-expert-pro-edition-subscription-service')">Order Now</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <p class="mt-3 mb-0">We offer software customization and integration services. Please email <a href="mailto:info@geoastra.com">info&#64;geoastra.com</a> to discuss your needs.</p>
  </div>
</div>

<!-- ppk-studio-section -->
<div id="ppk-studio-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row py-2">
    <div class="col-12">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-2">PPK Studio</h1>
      <h2 class="display-5 lh-1 mb-3">Turn raw GNSS rover and base data into centimeter-level accuracy positions, with quality plots, satellite map verification, and multiple export formats.</h2>
    </div>
  </div>

  <div class="row pt-2 pb-4">
    <div class="col-12">
      <img
        src="assets/images/landing/GeoAstra-ppk-studio-dataflow.png"
        class="img-fluid w-100 lnc-zoom-img ppk-studio-dataflow"
        alt="PPK Studio dataflow"
        loading="lazy"
        (click)="openLightbox('assets/images/landing/GeoAstra-ppk-studio-dataflow.png','PPK Studio dataflow')"
      >
    </div>
  </div>

  <div class="row flex-lg-row align-items-start g-4 g-lg-5 py-2">
    <div class="col-12 col-lg-7">
      <p class="mb-0 feature-intro">
        PPK Studio makes post-processed kinematic (PPK) positioning simple, fast, and reliable. As a web-based application, it requires no software installation or local setup—simply upload your rover and base station data, and the system automatically processes them into centimeter-level positioning results, with no complex configuration required. Resolved positions are displayed on an interactive plot with clear quality indicators, allowing you to quickly assess solution reliability. With a simple right-click, any data point can be viewed directly on Google satellite maps, making real-world verification intuitive and instant. PPK Studio also exports results in widely used formats—including SHP, GPX, KML/KMZ, and CSV—so your data is ready for immediate use in surveying, mapping, GIS, and drone workflows.
      </p>
    </div>
    <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
      <img src="assets/images/landing/GeoAstra_PPK_Studio_small.png"
           class="d-block img-fluid lnc-zoom-img feature-image"
           alt="GeoAstra PPK Studio"
           loading="lazy"
           (click)="openLightbox('assets/images/landing/GeoAstra_PPK_Studio_small.png','GeoAstra PPK Studio')">
    </div>
  </div>
</div>

<!-- ppk-downloader-pro-section -->
<div id="ppk-downloader-pro-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row py-2">
    <div class="col-12">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-2">PPK Downloader</h1>
      <h2 class="display-5 lh-1 mb-3">Automate RTCM downloads for PPK — from any NTRIP or CORS mountpoint.</h2>
    </div>
  </div>
  <div class="row flex-lg-row align-items-start g-4 g-lg-5 py-2">
    <div class="col-12 col-lg-7">
      <p class="mb-0 feature-intro">
        GeoAstra PPK Downloader makes high-precision PPK workflows simple, affordable, and fully automated by downloading RTCM correction data directly from any NTRIP CORS mountpoint. By eliminating the need to operate your own RTK Base, it cuts equipment costs by over 50% and allows you to focus entirely on Rover data collection. With scheduled downloads, hands-free automation, and the ability to capture centimeter-level accuracy anywhere — even without radios or internet — the PPK Downloader delivers a streamlined, reliable, and cost-effective solution for professional-grade PPK processing.
      </p>
    </div>
    <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
      <img src="assets/images/landing/GeoAstra_PPK_Downloader_diagram.drawio.png"
           class="d-block img-fluid lnc-zoom-img feature-image"
           alt="GeoAstra PPK Downloader"
           loading="lazy"
           (click)="openLightbox('assets/images/landing/GeoAstra_PPK_Downloader_diagram.drawio.png','GeoAstra PPK Downloader')">
    </div>
  </div>
</div>

<!-- rtk-base-analyzer-pro-section -->
<div id="rtk-base-analyzer-pro-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row py-2">
    <div class="col-12">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-2">RTK Base Analyzer</h1>
      <h2 class="display-5 lh-1 mb-3">Visualize Your Mountpoint and RTK Base Data</h2>
    </div>
  </div>
  <div class="row flex-lg-row align-items-start g-4 g-lg-5 py-2">
    <div class="col-12 col-lg-7">
      <p class="mb-0 feature-intro">
        GeoAstra RTK Base Analyzer gives you complete visibility into your RTK Base station by retrieving real-time data directly from any NTRIP mountpoint. Designed for surveyors and mapping professionals, it delivers millimeter-level base position accuracy, detailed GNSS signal insights, and comprehensive hardware and protocol information — all in one streamlined interface. With historical position tracking, SNR visualization, and multi-map base location viewing, the RTK Base Analyzer ensures your base is accurate, stable, and performing exactly as expected, bringing confidence and clarity to every GNSS workflow.
      </p>
    </div>
    <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
      <img src="assets/images/landing/GeoAstra_RTK_Base_Analyzer_diagram.drawio.png"
           class="d-block img-fluid lnc-zoom-img feature-image"
           alt="GeoAstra RTK Base Analyzer"
           loading="lazy"
           (click)="openLightbox('assets/images/landing/GeoAstra_RTK_Base_Analyzer_diagram.drawio.png','GeoAstra RTK Base Analyzer')">
    </div>
  </div>
</div>

<!-- stores-section -->
<div id="stores-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/images/landing/stores.png"
           class="d-block mx-lg-auto img-fluid lnc-zoom-img"
           alt="RTK GNSS Stores"
           width="700"
           height="500"
           loading="lazy"
           (click)="openLightbox('assets/images/landing/stores.png','RTK GNSS Stores')">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">RTK GNSS Stores</h1>
      <p>Are you looking to buy RTK devices?</p>
      <br>
      <h3>RTK Base</h3>
      <ul>
        <li>Looking for a cost-effective RTK base starting as low as US$249?</li>
        <li>In need of a commercial-grade fixed RTK base?</li>
        <li>Searching for a portable RTK base that doesn't require a fixed location and can be used on the go?</li>
        <li>Considering a dual-band or triple-band RTK base?</li>
      </ul>
      <br>
      <h3>RTK Rover</h3>
      <ul>
        <li>Seeking low-cost RTK GNSS receivers for large-scale deployments?</li>
        <li>Need an RTK GNSS compatible with your iPhone, Android phone, or Windows computer?</li>
        <li>Looking for a GNSS data logger?</li>
        <li>Searching for a GNSS module for your project?</li>
      </ul>
      <br>
      <h3>End-to-End RTK Solutions</h3>
      <ul>
        <li>Require a comprehensive RTK solution for high accuracy, including Base, NTRIP Caster, and Rover?</li>
        <li>Looking for end-to-end RTK data logger solutions?</li>
      </ul>
      <p>We believe the key to expanding the practical use of RTK solutions lies in affordability and ease of use. The products offered by the following webshops align with this philosophy, providing a wide range of RTK products to meet your needs. Check them out at</p>

      <br>
      <p><a href="https://gpswebshop.com" target="_blank" rel="noopener">GPSWebShop Online Store</a></p>
      <p><a href="https://canadagps.ca" target="_blank" rel="noopener">CanadaGPS Online Store</a></p>

      <div class="store-buttons mt-3">
        <a class="store-cta me-2" href="https://canadagps.ca/" target="_blank" rel="noopener" aria-label="Open Canada Store">
          <img src="assets/images/landing/Canada-SVG.svg" alt="Canada" class="ca-flag-img" />
          <span class="store-label">STORE</span>
        </a>
        <a class="store-cta" href="https://gpswebshop.com/" target="_blank" rel="noopener" aria-label="Open Global Store">
          <span class="material-icons icon icon-earth" style="color: #3b82f6;">language</span>
          <span class="store-label">STORE</span>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
    <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
  </div>
</div>
